import { Card, Flex, Image, Button } from "antd";
import React, { useMemo } from "react";
import { PlusOutlined } from "@ant-design/icons";
const Productcard = React.memo(({ product, onClickProduct }) => {
  const { title, price, price_range, mark_up_percentage, image_url } = product;

  // Memoize price calculation to avoid recomputation on re-renders
  const computedPrice = useMemo(() => {
    return price_range
      ? price_range
      : Math.ceil(
          parseFloat(price) +
            (parseFloat(price) * parseFloat(mark_up_percentage)) / 100
        );
  }, [price, price_range, mark_up_percentage]);

  // Styles
  const styles = {
    card: {
      width: "100%",
      padding: 2,
      cursor: "pointer",
      borderRadius: 28,
      boxShadow: "0 3px 6px rgba(0, 0, 0, 0.2)", // Add box-shadow here
      backgroundColor: "#fff",
      marginTop: 10,
    },
    imageWrapper: { marginRight: 12 },
    text: { margin: 0, textAlign: "left" },
  };

  return (
    <Card
      style={styles.card}
      size="small"
      bordered
      onClick={() => onClickProduct(product, product.Size || "[]")}
    >
      <Flex justify="start" align="center">
        <div style={styles.imageWrapper}>
          <Image
            preview={false}
            width={100}
            height={100}
            src={`https://groceria-storage.sgp1.cdn.digitaloceanspaces.com/assets/images/partner-merchant-menu/${image_url}`}
            style={{ display: "block", margin: "auto", borderRadius: 18 }}
            alt={title}
          />
        </div>
        <div style={{ flex: 1 }}>
          <p style={styles.text}>{title}</p>
          <p style={styles.text}>{computedPrice}</p>
        </div>
        <div style={{ marginRight: 15 }}>
          <Button
            onClick={() => onClickProduct(product, product.Size || "[]")}
            icon={<PlusOutlined />}
            type="primary"
            shape="circle"
            style={{ backgroundColor: "#00BF63", borderColor: "#00BF63" }}
          />
        </div>
      </Flex>
    </Card>
  );
});

export default React.memo(Productcard);
